import { render, staticRenderFns } from "./RiskProcessDrawer.vue?vue&type=template&id=1f414dc0&scoped=true&"
import script from "./RiskProcessDrawer.vue?vue&type=script&lang=js&"
export * from "./RiskProcessDrawer.vue?vue&type=script&lang=js&"
import style0 from "./RiskProcessDrawer.vue?vue&type=style&index=0&id=1f414dc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f414dc0",
  null
  
)

export default component.exports